export const INITIALIZE = 'folder:intialize';
export const SELECT_ONE = 'folder:select-one';
export const DESELECT_ONE = 'folder:deselect-one';
export const SELECT_ALL = 'folder:select-all';
export const DESELECT_ALL = 'folder:deselect-all';
export const TOGGLE_REORDER = 'folder:reorder';
export const CURRENT_FOLDER = 'folder:current';
export const SORT_TYPE = 'folder:sortType';
